import { render } from "./SectionSixteen.vue?vue&type=template&id=63bee59e&scoped=true"
import script from "./SectionSixteen.vue?vue&type=script&lang=js"
export * from "./SectionSixteen.vue?vue&type=script&lang=js"

import "./SectionSixteen.vue?vue&type=style&index=0&id=63bee59e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63bee59e"]])

export default __exports__